export function gain_produce(pid) {
	if (pid) {

		let temp_produce = false;
		for (let i in produce) {
			if (produce[i]['p_id'] === pid) {
				temp_produce = produce[i];
				break;
			}
		}

		switch (temp_produce['p_id']) {
			case 'pidenv_lsf': {
				temp_produce['table'] = createPid_lsf();
				break;
			}
			case 'pidenv_xf': {
				temp_produce['table'] = createPid_xf();
				break;
			}
		}

		return temp_produce;
	}
}

const produce = [
	{ p_id: 'pidenv_lsf', choose: false, p_name: '专版信封' },
	{ p_id: 'pidenv_xf', choose: false, p_name: '标准信封' },
]

// 标准信封
function createPid_xf() {
	return {
		// 成品尺寸
		p_chengpinchicun: {
			name: '成品尺寸',
			container: ['xx', 'yy', 'chichunstr', 'chichun'],
			data: [
				{
					type: 'select', name: '5号信封(DL号 220X110mm)', value: [254, 240, '220*110', '5号信封(220×110mm)'], choose: true, select_show: false, select_data: [
						{ name: '1号信封(165X100mm)', value: [207, 233, '165*102', '1号信封(165×102mm)'] },
						{ name: '2号信封(175X110mm)', value: [207, 233, '176*110', '2号信封(176×110mm)'] },
						{ name: '3号信封(B6号 176X125mm)', value: [210, 270, '176*125', '3号信封(176×125mm)'] },
						{ name: '5号信封(DL号 220X110mm)', value: [254, 240, '220*110', '5号信封(220×110mm)'] },
						{ name: '6号信封(ZL号 230X120mm)', value: [260, 260, '230*120', '6号信封(230×120mm)'] },
						{ name: '7号信封(C5号 229X162mm)', value: [265, 350, '229*162', '7号信封(229×162mm)'] },
						{ name: '8号信封(250X162mm)', value: [282, 375, '250*162', '8号信封(250×162mm)'] },
						{ name: '9号信封(C4号 324X229mm)', value: [370, 480, '324*229', '9号信封(324×229mm)'] },
					]
				},
				{ type: 'custom2', name: '自定义展开尺寸', value: [260, 260, '260*260', '展开尺寸:260×260'], choose: false }
			]
		},
		p_xinfeng: {
			name: '方式',
			container: 'fangshi',
			data: [
				{ type: 'default', name: '中式', value: '中式', choose: true },
				{ type: 'default', name: '西式平舌', value: '西式', choose: false },
				{ type: 'default', name: '西式尖舌', value: '西式', choose: false },
				{ type: 'default', name: '西式尖舌带插口', value: '西式', choose: false },
			]
		},
		// 刀模
		p_daomo: {
			name: '刀模',
			container: 'daomo',
			data: [
				{ type: 'default', name: '标准刀模', value: '0', choose: true },
				// { type: 'default', name: '定制刀模', value: '1', choose: false },
			]
		},
		// 材料克重
		p_cailiao: {
			name: '材料',
			container: ['cailiao', 'yongzhi'],
			data_multi: [
				{
					type: 'select', name: '双胶纸', value: '5', choose: true, level: '1', select_show: false, select_data: [
						{ name: '双胶纸', value: '5' },
						{ name: '黄牛皮', value: '9' },
						{ name: '白牛皮', value: '14' },
						{ name: '双铜纸', value: '1' },
						{ name: '单铜纸(白卡)', value: '2' },
						{ name: '哑粉纸', value: '3' },
						{ name: '冰白珠光纸', value: '13' },
					]
				},
				{
					type: 'select', name: '120克', value: 120, choose: true, level: '2', select_show: false, select_data: [
						{ name: '80克', value: 80 },
						{ name: '100克', value: 100 },
						{ name: '120克', value: 120 },
						{ name: '140克', value: 140 },
						{ name: '160克', value: 160 },
						{ name: '200克', value: 200 },
						{ name: '250克', value: 250 },
					]
				},
			],
			multi_list: [
				// 双胶纸
				[
					{ name: '80克', value: 80 },
					{ name: '100克', value: 100 },
					{ name: '120克', value: 120 },
					{ name: '140克', value: 140 },
					{ name: '160克', value: 160 },
					{ name: '200克', value: 200 },
					{ name: '250克', value: 250 },
				],
				// 黄牛皮
				[
					{ name: '80克', value: 80 },
					{ name: '100克', value: 100 },
					{ name: '120克', value: 120 },
					{ name: '150克', value: 150 },
					{ name: '180克', value: 180 },
					{ name: '200克', value: 200 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
					{ name: '400克', value: 400 },
				],
				// 白牛皮
				[
					{ name: '100克', value: 100 },
					{ name: '120克', value: 120 },
					{ name: '150克', value: 150 },
					{ name: '180克', value: 180 },
					{ name: '200克', value: 200 },
					{ name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
				],
				// 双铜纸
				[
					{ name: '105克', value: 105 },
					// { name: '120克', value: 120 },
					{ name: '128克', value: 128 },
					// { name: '140克', value: 140 },
					// { name: '150克', value: 150 },
					{ name: '157克', value: 157 },
					{ name: '200克', value: 200 },
					// { name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
					// { name: '400克', value: 400 },
				],
				// 单铜纸
				[
					{ name: '190克', value: 190 },
					{ name: '210克', value: 210 },
					{ name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
				],
				// 哑粉纸
				[
					{ name: '105克', value: 105 },
					{ name: '128克', value: 128 },
					{ name: '157克', value: 157 },
					{ name: '200克', value: 200 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
				],
				// 冰白珠光纸
				[
					{ name: '120克', value: 120 },
					{ name: '140克', value: 140 },
					{ name: '160克', value: 160 },
					{ name: '200克', value: 200 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
				],
			]
		},
		// 印刷颜色
		p_yinshuayanse: {
			name: '印刷颜色',
			container: 'ysys',
			data: [
				{ type: 'default', name: '彩色', value: '4', choose: true },
				{ type: 'default', name: '双色', value: '2', choose: false },
				{ type: 'default', name: '单色', value: '1', choose: false },
				{ type: 'default', name: '无', value: '0', choose: false },
			]
		},
		// 印刷款数
		p_kuanshu: {
			name: '印刷款数',
			container: 'pinzhong',
			data: [
				{ type: 'default', name: '1', value: 1, choose: true, },
				{ type: 'default', name: '2', value: 2, choose: false, },
				{ type: 'default', name: '3', value: 3, choose: false, },
				{ type: 'default', name: '4', value: 4, choose: false, },
				{ type: 'default', name: '5', value: 5, choose: false, },
				{ type: 'default', name: '6', value: 6, choose: false, },
				{ type: 'default', name: '7', value: 7, choose: false, },
				{ type: 'custom1', name: '', value: 9, choose: false, },
			],
		},
		// 印刷数量
		p_yinshuashuliang: {
			name: '印刷数量',
			container: 'shuliang',
			data: [
				{ type: 'default', name: '500', value: 500, choose: true, },
				{ type: 'default', name: '1000', value: 1000, choose: false, },
				{ type: 'default', name: '2000', value: 2000, choose: false, },
				{ type: 'default', name: '3000', value: 3000, choose: false, },
				{ type: 'default', name: '5000', value: 5000, choose: false, },
				{ type: 'default', name: '10000', value: 10000, choose: false, },
				{ type: 'custom1', name: '', value: 20000, choose: false, },
			],
		},
		//后道工序
		p_houdaogongxu: {
			name: '后道工序',
			data_after: [
				{
					container: 'hjg',
					must: true,
					reduce: true, //缩小排放
					data: [
						{
							type: 'default',
							name: '模切',
							value: '模切',
							choose: true,
						},
					],
				},
				{
					container: 'hjg',
					must: true,
					reduce: true,
					data: [
						{
							type: 'default',
							name: '粘',
							value: '粘成品',
							choose: true,
						},
					],
				},
				{
					container: 'bmcl',
					must: false,
					data: [
						{
							type: 'select',
							name: '单面亮膜',
							value: '覆亮膜',
							choose: false,
							select_show: false,
							select_data: [
								{ name: '单面亮膜', value: '覆亮膜' },
								{ name: '单面哑膜', value: '覆哑膜' },
								{ name: '单面防刮花哑膜', value: '防刮花哑膜' },
								{ name: '单面触感膜', value: '触感膜' },
								{ name: '单面镭射膜', value: '镭射膜' },
							],
						},
					],
				},
				{
					container: 'bmcl',
					must: false,
					data: [
						{
							type: 'select',
							name: '单面过光油',
							value: '过光油',
							choose: false,
							select_show: false,
							select_data: [
								{ name: '单面过光油', value: '过光油' },
								// { name: "单面过哑油", value: "过哑油" },
							],
						},
					],
				},
				{
					container: 'hjg',
					must: false,
					data: [
						{ type: 'default', name: '带自粘(打口水胶)', value: '带自粘', choose: false },
					]
				},
				{
					container: ['hjgzdy3', 'hjgzdy2'],
					must: false,
					data: [
						{
							type: 'select', name: '贴双面胶	', value: ['', '4586'], choose: false, select_show: false, select_data: [
								{ name: '贴双面胶', value: ['', '4586'] },
								{ name: '贴离型胶', value: ['4587', ''] },
							]
						}
					]
				},
				{
					container: ['jtx', 'jty', 'hjg','jtCl'],
					must: false,
					data: [
						{
							type: 'select',
							custom2: true,
							unit: 'mm',
							name: '普通击凸版',
							value: [90, 50, '击凸','25548'],
							choose: false,
							select_show: false,
							select_data: [
								{ name: '普通击凸版', value:[90, 50, '击凸','25548'], },
								{ name: '加厚击凸版', value: [90, 50, '击凸','25549'], },
							],
						},
					],
				},
				{
					container: ['tjx', 'tjy', 'tangCl', 'hjg'],
					must: false,
					data: [
						{
							type: 'select',
							custom2: true,
							unit: 'mm',
							name: '普通平烫',
							value: [150, 150, '25552', '烫金'],
							choose: false,
							select_show: false,
							select_data: [
								{
									name: '普通平烫',
									value: [150, 150, '25552', '烫金'],
								},
								{
									name: '浮雕烫',
									value: [150, 150, '25551', '烫金'],
								},
							],
						},
					],
				},
				{
					container: 'tjys',
					must: false,
					data: [
						{
							type: 'select', name: '烫黄金', value: '烫金', choose: false, select_show: false, select_data: [
								{ name: '烫黄金', value: '烫金' },
								{ name: '烫哑金', value: '烫金' },
								{ name: '烫红金', value: '烫金' },
								{ name: '烫蓝金', value: '烫金' },
								{ name: '烫黑金', value: '烫金' },
								{ name: '烫银', value: '烫金' },
								{ name: '烫特殊颜色金', value: '烫金' },
							]
						}
					]
				},
			],
		}
	}
}



// WEBPACK FOOTER //
// ./src/seal/proEnvelopes.js